import React, { useEffect, useState } from "react";
import { useHistory, useParams, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  HomeIcon,
  PdfIcon,
  ImageIcon,
  VideosIcon,
  DocumentIcon,
  ExcelIcon,
  DeleteIcon,
  PLusIcon,
  ThreeDotIcon,
  ShareIcon,
} from "../../assets/Icons";
import Search from "../../common/Search";
import FilterBtn from "../Workflow/FilterBtn";
import FileUploaderModal from "../../common/FileUploaderModal";
import ShareModal from "../../common/ShareModal";
import RenameFileModal from "./RenameFileModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { allFiles } from "./FilesData";
import axios from "axios";
import { UNO_URL } from "../../Server";
import { fileTypeIcons } from "../../constant/constant";
import FilePreviewModal from "./FilePreview";
import NoDataFound from "../../common/NoDataFound";
import FileSkeletonCard from "./FilesSkelton";

const FilesList = ({ user, userDetails }) => {
  const { type, uuid } = useParams(); // "pdf", "images", "videos"...
  const [search, setSearch] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const history = useHistory();
  const [showUploader, setShowUploader] = useState(false);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedFileForRename, setSelectedFileForRename] = useState(null);
  const [selectedFileForShare, setSelectedFileForShare] = useState(null);
  const [filesList, setFilesList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [storageCategoryId, setStorageCategoryId] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);

  const handleOpenPreview = (file) => {
    setPreviewFile(file);
    setShowPreview(true);
  };

  const handleClosePreview = () => {
    setPreviewFile(null);
    setShowPreview(false);
  };

  useEffect(()=>{
     let _selectedFiles = [...selectedFiles];
     let checkedAllFileSelected = filesList.length > 0 && filesList.every((e) => _selectedFiles.includes(e.uuid));
     setIsChecked(checkedAllFileSelected);
  },[selectedFiles, filesList])

  const getDriveFolderFiles = async (userToken) => {
    try {
      setLoading(true);
      let bodyTags = {
        tags: selectedCheckboxes.map((e) => e.value),
      };

      let { data } = await axios.post(`${UNO_URL}/api/drive/folder/files/${uuid}`, bodyTags, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      setFilesList(data.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getStorageCategoryTags = async (id) => {
    try {
      let categoryId = id || storageCategoryId;
      const { data } = await axios.get(`${UNO_URL}/api/tag/list/${categoryId}`, {
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
          "Content-Type": "application/json",
        },
      });

      let tagsList = data?.data?.tags || [];
      setTagsList(tagsList);

      let _tagsList = tagsList.map((tag) => ({
        name: tag.name,
        key: tag.id,
        value: tag.id,
      }));

      setFilterData([
        {
          name: "Tags",
          tags: _tagsList,
        },
      ]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const storageConfig = localStorage.getItem("configuration");
    const configData = JSON.parse(storageConfig);
    const _storageCategoryId = configData?.storageCategoryId || null;
    setStorageCategoryId(_storageCategoryId);
    if (userDetails?.token) {
      getStorageCategoryTags(_storageCategoryId);
    }
  }, [user, userDetails]);


  useEffect(() => {
    const timeout = setTimeout(() => {
      if (userDetails?.token) {
        getDriveFolderFiles(userDetails.token);
      }
    }, 750);

    return () => clearTimeout(timeout);
  }, [userDetails, selectedCheckboxes])

  const files = allFiles[type] || [];

  const getFileBaseName = (filename) => filename.replace(/\.[^/.]+$/, "");
  const capitalizeWords = (str) =>
    str
      ? str
          .split(" ")
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(" ")
      : "";

  const handleSelectAllFiles = () => {
    if (isChecked) {
      setSelectedFiles([]);
    } else {
      setSelectedFiles(filesList.map((e) => e.uuid));
    }
  };

  const handleSingleFileSelect = (uuid) => {
    let ids = [...selectedFiles];
    let newIds = ids.includes(uuid) ? ids.filter((n) => n !== uuid) : [...ids, uuid];
    setSelectedFiles([...newIds]);
  };

  const handleOpenShareModal = (file) => {
    setSelectedFileForShare(file);
    setShowShareModal(true);
  };
  const handleCloseShareModal = () => {
    setSelectedFileForShare(null);
    setShowShareModal(false);
  };

  const handleOpenRenameModal = (file) => {
    setSelectedFileForRename(file);
    setShowRenameModal(true);
  };
  const handleCloseRenameModal = () => {
    setSelectedFileForRename(null);
    setShowRenameModal(false);
  };

  const handleDeleteFile = async (uuids) => {
    if (window.confirm("Are you sure you want to delete the selected files permanently?")) {
      await axios.post(
        `${UNO_URL}/api/drive/delete/files`,
        { ids: uuids },
        {
          headers: {
            Authorization: `Bearer ${userDetails.token}`,
          },
        }
      );

      getDriveFolderFiles(userDetails.token);
      setSelectedFiles([...selectedFiles].filter((e) => !uuids.includes(e)));
    }
  };

  const handleFileRenameSubmit = async (bodyData, uuid) => {
    await axios.post(`${UNO_URL}/api/drive/rename/file/${uuid}`, bodyData, {
      headers: {
        Authorization: `Bearer ${userDetails.token}`,
      },
    });
    getDriveFolderFiles(userDetails.token);
  };

  const handleSelectTags = (item) => {
    setSelectedCheckboxes((prev) => {
      const exists = prev.some((i) => i.key === item.key);
      if (exists) {
        return prev.filter((i) => i.key !== item.key);
      } else {
        return [...prev, item];
      }
    });
  };

  let filterFiles = filesList.filter((e) => e.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="xp-breadcrumbbar">
      <div className="xp-page-title">
        <h3 className="xp-page-title">{capitalizeWords(type)} Files</h3>
      </div>

      <div className="row">
        <div className="col-md-9 col-lg-9">
          <div className="xp-breadcrumb gradient-border">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a onClick={() => history.push("/dashboard")} style={{ cursor: "pointer" }}>
                  <i>
                    <HomeIcon />
                  </i>
                </a>
              </li>
              <li className="breadcrumb-item">
                <a onClick={() => history.push("/files")}>Files</a>
              </li>
              <li className="breadcrumb-item active">{capitalizeWords(type)} Files</li>
            </ol>
          </div>
        </div>

        <div className="col-md-3 col-lg-3 filter-tab">
          <Search onChange={(e) => setSearch(e.target.value)} value={search} placeholder="Search..." />
          <FilterBtn
            selectedCheckboxes={selectedCheckboxes}
            handleReset={() => setSelectedCheckboxes([])}
            handleCheckboxChange={(e) => handleSelectTags(e)}
            filterOptions={filterData}
          />
        </div>
      </div>

      <div className="file-container">
        <div className="file-header d-flex justify-content-between align-items-center">
          <div className="actionbtns d-flex align-items-center">
            {filterFiles.length > 0 && (
              <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-share">Select All</Tooltip>}>
                <div className="custom-control custom-checkbox mr-2">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="fileCheck"
                    checked={isChecked}
                    onChange={(e) => handleSelectAllFiles(e)}
                  />
                  <label className="custom-control-label cursor-pointer" htmlFor="fileCheck">
                    {/* Select All */}
                  </label>
                </div>
              </OverlayTrigger>
            )}

            {filterFiles.length > 0 && selectedFiles.length > 0 && (
              <>
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-share">Delete Selected</Tooltip>}>
                  <span className="deletebtn cursor-pointer" onClick={() => handleDeleteFile(selectedFiles)}>
                    <DeleteIcon />
                  </span>
                </OverlayTrigger>
                {/* <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-share">Share Selected</Tooltip>}>
                  <span
                    className="cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      handleOpenShareModal();
                    }}
                  >
                    <ShareIcon />
                  </span>
                </OverlayTrigger> */}
              </>
            )}
          </div>

          <div className="btn btn-white btn-lg rounded border p-11" onClick={() => setShowUploader(true)}>
            <PLusIcon /> Add Files
          </div>
        </div>

        {/* <div className="file-grid"> */}
        {loading ? (
          // <p>Data is fetching</p>
          <FileSkeletonCard count={5} />
        ) : filterFiles.length === 0 ? (
          <NoDataFound headText="No Data found." />
        ) : (
          <>
            <div className="file-grid">
              {filterFiles.map((file, idx) => (
                <div className="file-card">
                  <div className="custom-control custom-checkbox listcheckbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id={`fileCheck-${idx}`}
                      checked={selectedFiles.includes(file.uuid)}
                      onChange={() => handleSingleFileSelect(file.uuid)}
                    />
                    <label className="custom-control-label" htmlFor={`fileCheck-${idx}`}></label>
                  </div>

                  <div className="customdropdown dropdown show">
                    <a
                      href="#"
                      role="button"
                      id="dropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <ThreeDotIcon />
                    </a>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                      {/* <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handleOpenShareModal(file) }} >
                      Share File
                    </a> */}
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleOpenRenameModal(file);
                        }}
                      >
                        Edit File
                      </a>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleDeleteFile([file.uuid]);
                        }}
                      >
                        Delete File
                      </a>
                    </div>
                  </div>

                  {/* <div className={`file-icon ${type ? type : ""}`}>{fileTypeIcons[type].icon}</div> */}

                  <div
                    className={`file-icon ${type ? type : ""}`}
                    onClick={() => handleOpenPreview(file)}
                    style={{ cursor: "pointer" }}
                  >
                    {fileTypeIcons[type].icon}
                  </div>
                  <p className="file-name">{file.name}</p>
                  <ul className="tags-list">
                    {file?.tags?.map((e) => (
                      <li>{e.name} </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </>
        )}
        {/* </div> */}
      </div>

      <FileUploaderModal
        show={showUploader}
        onClose={() => setShowUploader(false)}
        fileType={type}
        token={userDetails?.token}
        folderId={uuid}
        getDriveFolderFiles={() => getDriveFolderFiles(userDetails.token)}
        getStorageCategoryTags={getStorageCategoryTags}
        tagsList={tagsList}
      />

      {/* <ShareModal
        show={showShareModal}
        onClose={handleCloseShareModal}
        selectedWorkflow={selectedFileForShare}
        subGroups={{}}
        userDetails={userDetails}
        headingName="File"
        /> */}

      <RenameFileModal
        show={showRenameModal}
        onClose={handleCloseRenameModal}
        file={selectedFileForRename}
        handleFileRenameSubmit={handleFileRenameSubmit}
        userDetails={userDetails}
        tagsList={tagsList}
        getStorageCategoryTags={getStorageCategoryTags}
      />

      <FilePreviewModal show={showPreview} handleClose={handleClosePreview} file={previewFile} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.userData,
  userDetails: state.userData.userDetails,
});

export default withRouter(connect(mapStateToProps)(FilesList));
